import { gql } from '@apollo/client';

export const USER_REGISTRATION_ROLES = gql`
  query UserRegistrationRoles($input: RegistrationRoleFilterInput!) {
    registrationRoles: getUserRegistrationRoles(input: $input) {
      id
      name
    }
  }
`;
